export const addPrintClickPointLayer = (map: maplibregl.Map, lng: number, lat: number) => {
    const pointSourceId = 'print-click-point';
    const pointLayerId = 'print-click-point-layer';

    // 既存のソース・レイヤーがあれば削除
    if (map.getLayer(pointLayerId)) map.removeLayer(pointLayerId);
    if (map.getSource(pointSourceId)) map.removeSource(pointSourceId);

    // GeoJSONソースを追加
    map.addSource(pointSourceId, {
        type: 'geojson',
        data: {
            type: 'FeatureCollection',
            features: [{
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [lng, lat]
                },
                properties: {}
            }]
        }
    });

    // レイヤーを追加（circleからsymbolに変更し、map-pinスプライトを指定）
    map.addLayer({
        id: pointLayerId,
        type: 'symbol',
        source: pointSourceId,
        layout: {
            'icon-image': 'map-pin-red', // スプライト名
            'icon-size': 0.4,
            'icon-anchor': 'bottom'
        }
    });
};
